export enum FormIds {
  SHIPMENT_SIDEBAR_DETAIL_FORM = 'shipment_sidebar_detail_form',
  CONTACT_SIDEBAR_DETAIL_FORM = 'contact_sidebar_detail_form',
  PRODUCT_SIDEBAR_DETAIL_FORM = 'product_sidebar_detail_form',
  CONTACT_FORM = 'contact_form',
  PRODUCT_FORM = 'product_form',
  ADD_SHIPMENT_FORM = 'add_shipment_form'
}
